import { ModalRoot } from '@ui-kit/components/Modal/Modal';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import type { ModalComponent } from '@/components/ModalRenderer/modalMap';
import modalMap from '@/components/ModalRenderer/modalMap';
import { useModalStore } from '@/store/modalStore';

const ModalRenderer = () => {
  const { pathname } = useLocation();
  const { currentModal, status, closeModal, closeNonPersistedModal } = useModalStore();

  useEffect(() => {
    closeNonPersistedModal();
  }, [closeNonPersistedModal, pathname]);

  const activeModal = status === 'idle' && currentModal ? currentModal : null;
  const ModalComponent = activeModal ? (modalMap[activeModal.type] as ModalComponent) : null;
  const handleClose = activeModal?.options.closeAction ?? closeModal;

  return (
    <ModalRoot isOpen={!!activeModal} onDismiss={handleClose}>
      {activeModal && ModalComponent ? (
        <ModalComponent
          key={activeModal.type}
          payload={activeModal.options.payload}
          confirmAction={activeModal.options.confirmAction}
          closeModal={handleClose}
        />
      ) : null}
    </ModalRoot>
  );
};

export default ModalRenderer;
